import type { TableDraftSummary } from './hospitalityTypes';

/**
 * Badges cortos en tarjeta/mapa de Mesas (guest tableside).
 * Evitar palabras ambiguas (“Avisó”, “Armando” se lee como nombre).
 */
export function guestActivityBadgeBits(g: TableDraftSummary): string[] {
  const bits: string[] = [];
  if (g.hasCallWaiter) bits.push('Llaman al mozo');
  // Guest "Ya pedí" → ready_to_order. No “Avisaron” (vago) ni “listos para pedir” (suena a cocina).
  if (g.hasReadyToOrder) bits.push('Ya pidieron');
  if (g.hasRequestBill) bits.push('Piden la cuenta');
  if (g.draftLineCount > 0) {
    bits.push(
      g.draftLineCount === 1
        ? '1 ítem en el pedido'
        : `${g.draftLineCount} ítems en el pedido`,
    );
  } else if (g.lookingGuestCount > 0 && bits.length === 0) {
    bits.push('Mirando la carta');
  }
  return bits;
}
